import React, { Fragment } from 'react';

export function If({ children, _if, _else }) {
  if (_if) {
    return children(true);
  } else {
    return <Fragment>{_else}</Fragment>;
  }
}
